export const APPROVALS_FILTER_KEY_SEARCH = 'searchString';
export const APPROVALS_FILTER_KEY_DATE_RANGE = 'dateRange';
export const APPROVALS_FILTER_KEY_DEPARTMENT_IDS = 'departmentIds';
export const APPROVALS_FILTER_KEY_PROJECT_IDS = 'projectIds';
export const APPROVALS_FILTER_KEY_MEMBER_IDS = 'memberIds';
export const APPROVALS_FILTER_KEY_STATUSES = 'statuses';

// searchString is intentionally excluded: it is marked saveable: false in the
// filter config and should not be persisted across sessions.

export const APPROVALS_TABLE_FILTER_KEYS = [
  APPROVALS_FILTER_KEY_DATE_RANGE,
  APPROVALS_FILTER_KEY_DEPARTMENT_IDS,
  APPROVALS_FILTER_KEY_PROJECT_IDS,
  APPROVALS_FILTER_KEY_MEMBER_IDS,
  APPROVALS_FILTER_KEY_STATUSES,
];

export const APPROVALS_TABLE_FILTERS_STORAGE_KEY = 'time-tracking-approvals-table-filters';
